export default "__VITE_ASSET__BCcxlPyA__"